import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '../../shared/header/header.component';
import { FormsModule } from '@angular/forms';
import { ProductsComponent } from '../products/products.component';
import { NgbActiveModal, NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-nav-bar',
  standalone: true,
  imports: [RouterModule, HeaderComponent, CommonModule, FormsModule, ProductsComponent, NgbTooltipModule],
  templateUrl: './nav-bar.component.html',
  styleUrl: './nav-bar.component.scss'
})
export class NavBarComponent {
  employee_details: any;
  isCollapsed: boolean = true;
  hoverExpanded = false;
  modalshow: boolean = false
    // @Input() isOpen!: boolean;
  constructor(private modalService: NgbModal,public activeModal: NgbActiveModal) {

  }
   ngOnInit(): void {
    // console.log(this.isOpen,'isOpen')
   }
  // toggleSidebar() {
  //   console.log(this.isCollapsed, 'this.isCollapsedthis.isCollapsed')
  //   this.isCollapsed = !this.isCollapsed;
  //   this.isCollapsed = true
  // }
  onSidebarHover(isHovering: boolean) {
    // if (this.isCollapsed) {
    //   this.hoverExpanded = isHovering;
    // }
  }
  closeSidebar() {
    // this.isCollapsed = true;
    // this.modalService.dismissAll()
    // this.modalshow = false
    this.activeModal.close();
  }
}
